module.exports = __webpack_public_path__ + "static/media/nBkPoY1NIl.8baa3698.jpg";